module.exports = {
  footerText: 'Tahsilite © 2025',
}
